import { Context } from "@grandvisionhq/carts-v2";
import { useSelector, IntlSelectors, useFeatureToggles } from "@grandvisionhq/state";
import { getChangedOptIns } from "../../../../selectors.js";
import { getShippingData, getSelectedShippingMethod, getSelectedStore, getSelectedPickupPoint } from "../../../../StepShipping/StepShipping/selectors.js";
import { getSelectedOptIns } from "../../../../utils/utils/get-selected-opt-ins.js";
import { getCustomerDetailsPayload } from "../../../../utils/utils/get-customer-details-payload.js";
const usePrepareCustomerDetails = () => {
  const shippingDetails = useSelector(getShippingData);
  const selectedShippingMethod = useSelector(getSelectedShippingMethod);
  const selectedStore = useSelector(getSelectedStore);
  const selectedPickupPoint = useSelector(getSelectedPickupPoint);
  const changedOptIns = useSelector(getChangedOptIns);
  const countryCode = useSelector(IntlSelectors.getCountry);
  const locale = useSelector(IntlSelectors.getLocale);
  const { isMultilingualEnabled } = useFeatureToggles();
  const { cart } = Context.useCart();
  let selectedOptIns = [];
  if (changedOptIns) {
    selectedOptIns = getSelectedOptIns(changedOptIns);
  }
  if (shippingDetails && countryCode && selectedShippingMethod) {
    return {
      customerDetails: {
        ...getCustomerDetailsPayload({
          shippingDetails,
          opcoCountry: countryCode,
          locale,
          isMultilingualEnabled,
          selectedPickupPoint,
          selectedShippingMethod: selectedShippingMethod.method,
          selectedStore,
          cartShippingAddress: cart?.shippingAddress
        }),
        marketingEmailsOptIn: selectedOptIns.includes("marketingEmailsOptIn")
      }
    };
  } else {
    throw new Error(
      "Need to have shipping details, shippingMethods and a selected shipping method to update on cart!"
    );
  }
};
export {
  usePrepareCustomerDetails
};
//# sourceMappingURL=use-prepare-customer-details.js.map
